import React, { useRef } from 'react';
import NavbarComponent from '../components/NavbarComponent';
import HeroSection from '../components/HeroSection';
import ChallengesSection from '../components/ChallengesSection';
import SolutionsSection from '../components/SolutionsSection';
import DigitalBrandingSection from '../components/DigitalBrandingSection';
import DigitalActivitiesSection from '../components/DigitalActivitiesSection';
import AboutSection from '../components/AboutSection';
import Footer from '../components/Footer';
// import BenefitsSection from '../components/BenefitsSection';
// import CallToAction from '../components/CallToAction';
// import ServicesSection from '../components/ServicesSection';
// import SEOSetup from '../components/SEOSetup';
// import MaintenanceNotice from '../components/MaintenanceNotice';

function Home() {
  // Define refs for each section
  const homeRef = useRef(null);
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null); // Optional: for footer or future contact section

  // Smooth scroll function
  const scrollToSection = (section) => {
    const refs = {
      home: homeRef,
      services: servicesRef,
      about: aboutRef,
      contact: contactRef,
    };
    refs[section]?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* <SEOSetup /> */}
      {/* <MaintenanceNotice /> */}
      <NavbarComponent scrollToSection={scrollToSection} />

      <div ref={homeRef}>
        <HeroSection />
      </div>

      <ChallengesSection />

      <div ref={servicesRef}>
        <SolutionsSection />
        <DigitalBrandingSection />
        <DigitalActivitiesSection />
      </div>

      {/* <BenefitsSection /> */}
      {/* <CallToAction /> */}
      {/* <ServicesSection /> */}

      <div ref={aboutRef}>
        <AboutSection />
      </div>

      {/* Optional contact section */}
      <div ref={contactRef}>
        <Footer />
      </div>
    </>
  );
}

export default Home;
